export default {
      id: "pattern-mutame-video-usage",
      viewBox: "0 0 1920 479",
      url: "../icon/" + "icons.svg#pattern-mutame-video-usage",
      toString: function () {
        return this.url;
      }
    }